// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import 'normalize.css/normalize.css' // normalize.css 样式格式化
import App from './App'
import store from './store'
import router from './router/index'

import './assets/icons' // icon
import './permission' // permission control
import moment from 'moment' // 导入 Moment.js
moment.locale('zh-cn')

import common from '@/utils/common'
import stompGlobal from '@/utils/stomp'
import * as filters from './filters' // 全局vue filter
// 水波纹指令
import vueWaves from './directive/waves'
import InputDirect from './directive/input' // input 全局指令
import horizontalScroll from './directive/horizontalScroll'
import clipboard from './directive/clipboard.js'

// 使用createEl方法下拉无法选中
import switchGroup from '@/views/components/switchGroup.vue'
// errorlog 组件
import errLog from '@/store/errLog'
// 分页组件
import Pagination from '@/components/Pagination'
// 限制日期组件
import MyDatePicker from '@/components/MyDatePicker'

// 全局mixin
import commonMixin from '@/mixin/common'
import scrollbarResetMixin from '@/mixin/scrollbarReset'

Vue.mixin(commonMixin)
Vue.mixin(scrollbarResetMixin)

// 全局方法挂载
Vue.prototype.common = common
Vue.prototype.stompGlobal = stompGlobal
Vue.prototype.$moment = moment // 赋值使用

// 全局组件挂载
Vue.component('switchGroup', switchGroup)
Vue.component('Pagination', Pagination)
Vue.component('MyDatePicker', MyDatePicker)

// 全局过滤器挂载
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.use(ElementUI)
Vue.use(vueWaves)
Vue.use(InputDirect)
Vue.use(horizontalScroll)
Vue.use(clipboard)

Vue.config.productionTip = false

// 生产环境错误日志
if (process.env.NODE_ENV === 'production') {
  const errorHandler = (err, vm) => {
    console.log(err, window.location.href)
    errLog.pushLog({
      err,
      url: window.location.href,
      vm
    })
  }

  Vue.config.errorHandler = errorHandler
  Vue.prototype.$throw = (error) => errorHandler(error, this)
}

// 图片系统初始化
// import { init, OTExplorerComp } from 'opfs-tools-explorer';
// init();

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
// 图片系统初始化
// Vue.render = h => h(<OTExplorerComp />)
